import { render, staticRenderFns } from "./cEditor.vue?vue&type=template&id=2bd7b640&scoped=true"
import script from "./cEditor.vue?vue&type=script&lang=js"
export * from "./cEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd7b640",
  null
  
)

export default component.exports